export default __webpack_public_path__ + "static/media/Paper.70130b16.svg";